<template>
  <h3 class="flex-grow-1 speedee-bold p-2">Home</h3>

  <div class="card text-center speedee-regular">
    <div
      class="card-header d-flex"
      :style="{
        backgroundColor: isPending ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }"
    >
      <h5 class="flex-grow-1">Hero Banner</h5>
      <button
        v-if="!isPending && !isApprover"
        class="float-right btn btn-info editHeroBanner"
        data-bs-toggle="modal"
        data-bs-target="#editHeroBanner"
      >
        <i class="fa fa-pencil text-white"></i>
      </button>
      <span v-if="isPending" class="float-right btn bg-secondary"
        ><i class="fa fa-lock text-white"></i
      ></span>
    </div>
    <div class="card-body">
      <div
        style="
          border: dashed 1px black;
          padding: 20px;
          display: flex;
          flex-direction: row;
          gap: 20px;
        "
      >
        <div v-for="(banner, index) in banners" :key="index">
          <img
            :src="banner.image_url"
            style="
              width: 200px;
              height: 150px;
              object-fit: cover;
              border-radius: 10px;
              box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            "
          />
          <ApprovalComponent @submit-data="handleData($event)" :datas="datas" />
        </div>
      </div>
      <div class="float-right">
        <button @click="preview()" class="btn bg-light-dark text-dark m-2">
          Preview
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveHeroBanner(0)"
          class="btn bg-light-dark text-dark m-2"
        >
          Save Draft
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveHeroBanner(1)"
          class="btn btn-warning text-dark m-2"
        >
          Submit For Approval
        </button>
        <button
          v-if="isApprover && isPending"
          data-bs-toggle="modal"
          data-bs-target="#approveModal"
          class="btn btn-warning text-dark m-2 approveModal"
          @click="openApprovalModal(index_1, 'heroBanner')"
        >
          Approval
        </button>
      </div>
    </div>
  </div>

  <!-- modal component -->
  <div>
    <Modal
      :modalTitle="'Edit Hero Banner'"
      :modalSize="'modal-lg'"
      :id="'editHeroBanner'"
    >
      <div class="card text-dark">
        <div class="card-body">
          <div class="default-according style-1" id="accordionoc">
            <div
              v-for="(banner, index_1) in banners"
              :key="index_1"
              class="w-full d-flex gap-2 py-2"
            >
              <div class="card w-100">
                <div class="card-header bg-light-dark text-dark">
                  <h5 class="mb-0">
                    <button
                      class="btn bg-light-dark text-dark w-100"
                      :class="{ collapsed: !banner.banner_expanded }"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#collapseicon' + index_1"
                      aria-expanded="true"
                      :aria-controls="`collapseicon${index_1}`"
                    >
                      Slide
                      <span>{{ index_1 + 1 }}</span>
                    </button>
                  </h5>
                </div>
                <div
                  :class="['collapse', { show: banner.banner_expanded }]"
                  :id="`collapseicon${index_1}`"
                  :aria-labelledby="`collapseicon${index_1}`"
                  data-bs-parent="#accordionoc"
                >
                  <div class="card-body">
                    <div style="display: flex; flex-direction: column">
                      <label class="form-label speedee-bold float-left"
                        >Image</label
                      >
                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                        "
                      >
                        <img
                          :src="banner.image_url"
                          style="
                            width: 120px;
                            height: 120px;
                            object-fit: contain;
                            border-radius: 10px;
                            border: dashed 1px gray;
                          "
                        />
                        <div class="fileUpload bg-none text-left align-middle">
                          <div>
                            <span class="media-text p-2"
                              >Select from Media Library (Max dimension 1200 x
                              800 px)</span
                            >
                          </div>
                          <button
                            @click="openGalleryModal(index_1, 'editHeroBanner')"
                            aria-hidden="true"
                            class="mx-2 p-2 border w-auto"
                          >
                            Browse
                          </button>
                        </div>
                      </div>
                    </div>

                    <label class="form-label speedee-bold float-left"
                      >Category</label
                    >
                    <select
                      class="form-select"
                      v-model="banner.entity_category_id"
                      @change="handleEntityChange(index_1)"
                    >
                      <option
                        v-for="category in categories"
                        :key="category.id"
                        :value="category.id"
                      >
                        {{ category.entity }}
                      </option>
                    </select>
                    <div class="py-2 d-flex flex-column">
                      <label class="speedee-bold float-left">Type Title</label>
                      <v-select
                        v-model="banner.entity_name"
                        :options="titleOptions[index_1]"
                        label="name"
                        @input="handleCategoryChange(index_1)"
                        searchable
                        class="f-16"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  v-if="banners.length > 1"
                  class="btn bg-light-dark text-dark"
                  @click="removeSlide(index_1)"
                >
                  X
                </button>
              </div>
            </div>
            <button
              class="btn bg-light-dark text-dark text-center newSlideBtn"
              @click="addNewSlide"
            >
              +
            </button>
          </div>

          <button
            type="button"
            class="btn bg-light-dark text-dark mt-4 float-right mx-2"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            id="HeroSaveModalBtn"
            class="btn btn-warning text-dark mt-4 float-right"
            data-bs-dismiss="modal"
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
    <ImageComponent @add-image="handleAddImage($event)" />
  </div>
</template>

<script>
import Modal from "@/components/ModalComponent.vue";
import ImageComponent from "@/components/ImageComponent.vue";
import ApprovalComponent from "@/components/ApprovalComponent.vue";
import {
  getRequest,
  postRequest,
  patchRequest,
} from "@/services/RequestService";
import AutoComplete from "primevue/autocomplete";
import Dropdown from "primevue/dropdown";

export default {
  props: {
    banners: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    icm_banners: {
      type: Object, // Adjust the prop type based on your data structure
      required: true,
    },
    wwu_banner: {
      type: Object, // Adjust the prop type based on your data structure
      required: true,
    },
    product_banners: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    discovers: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    isApprover: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isPending: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isApproved: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
  },
  components: {
    Modal,
    ImageComponent,
    AutoComplete,
    ApprovalComponent,
    Dropdown,
  },

  data() {
    return {
      categories: [],
      isModalVisible: false,
      titleOptions: [],
      filteredOptions: [],
      datas: [],
      removedBannerIds: [],
    };
  },

  created() {
    this.banners.forEach((banner, index) => {
      this.titleList(index);
      this.bannerIsPending = banner.approval === "Pending";
    });
  },

  mounted() {
    this.bannerCategories();
    this.updatedData;
  },

  computed: {
    updatedData() {
      const updatedData = this.datas; // Copy datas to updatedData
      return updatedData;
    },
  },

  methods: {
    openGalleryModal(index, modalName) {
      var heroBannerModal = document.getElementById(modalName);
      var galleryModal = document.getElementById("galleryModal");
      var index = (document.getElementById("slideIndex").value = index);
      document.getElementById("modal_id").value = modalName;

      heroBannerModal.classList.remove("show");
      heroBannerModal.style.display = "none";

      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    handleAddImage(galleryId) {
      // Handle the added image ID here

      if (galleryId.modalName == "editHeroBanner") {
        this.banners[galleryId.index].image_id = galleryId.galleryId;
        this.banners[galleryId.index].image_url = galleryId.galleryUrl;
      }

      if (galleryId.modalName == "editNewSection") {
        this.product_banners[galleryId.index].image_id = galleryId.galleryId;
        this.product_banners[galleryId.index].image_url = galleryId.galleryUrl;
      }

      if (galleryId.modalName == "editDiscoverBanner") {
        this.discovers[galleryId.index].image_id = galleryId.galleryId;
        this.discovers[galleryId.index].image_url = galleryId.galleryUrl;
      }

      if (galleryId.modalName == "editWwuBanner") {
        this.wwu_banner.image_id = galleryId.galleryId;
        this.wwu_banner.image_url = galleryId.galleryUrl;
      }
    },

    openApprovalModal(index, modalName) {
      document.getElementById("data_id").value = modalName;
    },

    handleData(entityData) {
      if (entityData.dataName === "heroBanner") {
        this.datas = this.banners;
      } else if (entityData.dataName === "icmBanner") {
        this.datas = this.icm_banners;
      } else if (entityData.dataName === "newSection") {
        this.datas = this.product_banners;
      } else if (entityData.dataName === "discover") {
        this.datas = this.discovers;
      } else if (entityData.dataName === "wwuBanner") {
        this.datas = this.wwu_banner;
      }
    },

    addNewSlide() {
      // Check if both title and content are provided
      // Create a new accordion object
      const newSlide = {
        banner_expanded: false,
        categories: "",
        image_url: require("@/assets/images/empty.jpg"),
        entity_id: 1,
        entity: 1,
        url: null,
      };

      // Add the new accordion to the accordions array
      this.banners.push(newSlide);
    },

    removeSlide(index) {
      // Check if the index is valid
      if (index >= 0 && index < this.banners.length) {
        // Remove the element at the specified index from the banners array
        this.removedBannerIds.push(this.banners[index].id);
        this.banners.splice(index, 1);
      }
    },

    async bannerCategories() {
      let getCategory = await getRequest("banners/home/categories", true);
      this.categories = getCategory.data.data;
    },

    async saveHeroBanner(type) {
      let heroBanners = this.banners.map((banner, index) => ({
        id: banner.id,
        name: "Main Banner",
        gallery_id: banner.image_id,
        entity_id: banner.entity_id || banner.entity_name.id,
        entity: banner.entity_category_id,
        entity_name:
          typeof banner.entity_name === "object"
            ? banner.entity_name.name
            : banner.entity_name,
        url: banner.url,
      }));

      let response = await postRequest(
        "/banners/home",
        {
          banners: heroBanners,
          approval: type,
          removeBanner: this.removedBannerIds,
        },
        true
      );

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text:
            type === 0
              ? response.data.message
              : "Your Approval Request has been submitted for review.",
          confirmButtonText: "Close",
        }).then(function () {
          window.location.reload();
        });
      }
    },

    async preview() {
      if (this.isPending || (this.isApprover && this.isApproved)) {
        window.open("/?preview=1");
      } else {
        let heroBanners = this.banners.map((banner, index) => ({
          id: banner.id,
          name: "Main Banner",
          gallery_id: banner.image_id,
          entity_id: this.titleOptions[index].find(
            (obj) => obj.name == banner.entity_name
          )
            ? this.titleOptions[index].find(
                (obj) => obj.name == banner.entity_name
              ).id
            : null,
          entity: banner.entity_category_id,
          entity_name: banner.entity_name,
          url: banner.url,
        }));

        let response = await postRequest(
          "/banners/home",
          {
            banners: heroBanners,
            approval: 0,
            removeBanner: this.removedBannerIds,
          },
          true
        );

        if (response.data.success) {
          window.open("/?preview=1");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: response.data.message,
            confirmButtonText: "Close",
          });
        }
      }
    },

    /**dropdown for category*/
    async handleEntityChange(index) {
      //update title list based on the category change
      await this.titleList(index);

      this.entity_name = null;
    },

    /** fetch the categories list*/
    async titleList(index) {
      const selectedEntity = this.banners[index].entity_category_id;

      let getEntity = await getRequest(
        `banners/home/categories/${selectedEntity}/lists`,
        true
      );
      this.titleOptions[index] = getEntity.data.data;
    },

    /** get the dropdown list from the auto complete*/
    async searchOptions({ query }, index) {
      this.filteredOptions = this.titleOptions[index]
        .filter((option) =>
          option.name.toLowerCase().includes(query.toLowerCase())
        )
        .map((option) => option.name);

      if (!this.titleOptions[index].includes(this.banners[index].entity_name)) {
        this.banners[index].entity_name = this.banners[index].entity_name;
      }
    },
  },
};
</script>

<style scoped>
input[type="file"]::file-selector-button {
  border: none;
  background: lightgray;
  padding: 10px 20px;
  border-radius: 10px;
  color: black;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  background: lightgray;
  color: black;
}

.banner-item {
  width: 100%;
}

.newSlideBtn {
  width: 94% !important;
}

.modal:nth-of-type(even) {
  z-index: 10005 !important;
}
.modal-backdrop.show:nth-of-type(even) {
  z-index: 10004 !important;
}

.p-autocomplete {
  width: 100%;
}

.p-inputtext {
  width: "-webkit-fill-available";
}
</style>
